import { createContext, ReactNode, useEffect, useState } from 'react';
import { ReportRecommendationsModel } from '@/types/report/ReportRecommendationsModel';
import { ReportSearchModel } from '@/types';
import { reportRecommendations } from '@/api/report-data';

interface IRecommendationsContext extends ReportRecommendationsModel {
  pushToRecentSearches: (searchTerm: string) => void;
}

export const RecommendationsContext = createContext<IRecommendationsContext>({
  recentlyViewed: [],
  recentSearches: [],
  popularSeaches: [],
  popularReports: [],
  pushToRecentSearches: () => {},
});

export const RecommendationsContextElement = ({
  children,
  userId,
}: {
  children: ReactNode | undefined;
  userId?: string;
}) => {
  const [recentlyViewed, setRecentlyViewed] = useState<ReportSearchModel[]>([]);
  const [recentSearches, setRecentSearches] = useState<string[]>([]);
  const [popularSeaches, setPopularSeaches] = useState<string[]>([]);
  const [popularReports, setPopularReports] = useState<ReportSearchModel[]>([]);

  useEffect(() => {
    const loadUserData = async () => {
      if (userId) {
        reportRecommendations(userId).then((data) => {
          setRecentlyViewed(data.recentlyViewed);
          setRecentSearches(data.recentSearches);
          setPopularSeaches(data.popularSeaches);
          setPopularReports(data.popularReports);
        });
      }
    };
    loadUserData();
  }, [userId]);

  const pushToRecentSearches = (searchTerm: string) => {
    let updatedSearches = [...recentSearches];
    if (!updatedSearches.includes(searchTerm)) {
      updatedSearches = [searchTerm, ...updatedSearches];
      if (updatedSearches.length > 3) {
        updatedSearches = updatedSearches.slice(0, 3);
      }
      setRecentSearches(updatedSearches);
    }
  };

  return (
    <RecommendationsContext
      value={{ recentlyViewed, recentSearches, popularSeaches, popularReports, pushToRecentSearches }}
    >
      {children}
    </RecommendationsContext>
  );
};
